export default __webpack_public_path__ + "82abce92a659e781b1a655be4ee0a7c8.svg";